import React, { useState, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import BreadCrumb from "../navbar/Breadcrumb";
import { UsuarioContext } from '../../providers/userContext';
import {
    Box,
    TextField,
    Button,
    InputAdornment,
    IconButton,
} from "@mui/material";
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { IoCloseOutline } from 'react-icons/io5';
import { House, IdCard, MapPin, Mail, Phone, User, RectangleEllipsis, MapPinned, AtSign, SquareUserRound } from 'lucide-react';
import { changePassword } from '../../services';
import { toast } from "react-toastify";
import CheckPass from './checkPass';
import AAFF from '../../routes/pages/aaff/AAFF';
import CaeToken from './caeToken';
import { getOneAAFF } from '../../services/aaffs.service';
import { cambiarFormatoNombre } from '../../functions/funciones';


const DatosPerfil = () => {
    const { t } = useTranslation('common');
    const user = useContext(UsuarioContext)
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showRepeatPassword, setShowRepeatPassword] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [oldPassword, setOldPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');
    const [error, setError] = useState('');
    const [passOk, setPassOk] = useState(false);
    const [envio, setEnvio] = useState(false);
    const [aaff, setAaff] = useState({});
    const [showChangePassword, setShowChangePassword] = useState(false);

    const isNewProfile = user?.tieneLegalia && user.rol === "AAFF";

    useEffect(() => {
        if (isNewProfile) {
            getOneAAFF(user.nif).then(res => {
                if (res) setAaff(res);
            });
        }
    }, [user.nif, isNewProfile]);

    

    function handleChange(e) {
        setOldPassword(e.target.value);
    }

    const handleChangePassword = (e) => {
        setEnvio(false)
        // validarPass(e.target.value)
        setNewPassword(e.target.value);
        
        if (repeatPassword && e.target.value !== repeatPassword) {
            setError(t('profile.passwordsNotMatch'));
        } else {
            setError('');
        }
        
    };
    
    const handleChangeRepeatPassword = (e) => {
        setEnvio(false)
        setRepeatPassword(e.target.value);
        
        if (newPassword && e.target.value !== newPassword) {
          setError(t('profile.passwordsNotMatch'));
        } else {
          setError('');
        }
    };

    const passValida = async (isValid) => {
        setPassOk(isValid)
    }

    const closePasswordModal = () => {
        setShowChangePassword(false);
        setOldPassword('');
        setNewPassword('');
        setRepeatPassword('');
        setError('');
        setEnvio(false);
        setShowOldPassword(false);
        setShowNewPassword(false);
        setShowRepeatPassword(false);
    }

    const handleSubmit = async () => {
        let toastInfo = undefined
        setEnvio(true)
        // const isValid = validarPass(newPassword)
        const isValid = passOk
        
        if(isValid){
            const data = {
                oldPassword,
                newPassword,
            }
    
            for (const key in data) {
                if (data.hasOwnProperty(key) && data[key] === '') {
                  setError(t('profile.fillAllFields'));
                  return;
                }
            }
    
            if(error !== ''){
                if(newPassword !== repeatPassword){
                    setError(t('profile.passwordsNotMatch'));
                    return
                }else {
                    setError('');
                    return
                }
            }
            
            toastInfo = toast.info(t('profile.updatingPassword'), { autoClose: false });            
            const response = await changePassword(data)
            console.log(response)
            if(response.status === 403){
                toast.update( toastInfo, {
                    render: response.data.error[0],
                    type: toast.TYPE.ERROR,
                    autoClose: true
                })
            }
            if( response.message === "Minimum eight characters, at least one letter and one number"){
                setError(t('profile.passwordRequirements'))
                return
            }
            if( response.status === 200 && response.data.error === "PASSWORD_NOT_MATCH"){
                toast.update( toastInfo, {
                    render: t('profile.currentPasswordNotMatch'),
                    type: toast.TYPE.ERROR,
                    autoClose: true
                })
            }
    
            if( response.status === 200 && response.data.message === "PASSWORD_UPDATED"){
                toast.update( toastInfo, {
                    render: t('profile.passwordUpdated'),
                    type: toast.TYPE.SUCCESS,
                    autoClose: true
                })
                if (isNewProfile) closePasswordModal();
            }
            setOldPassword('')
            setNewPassword('')
            setRepeatPassword('')
        }else{
            return
        }
    }

    const renderPasswordFields = () => (
        <>
            <Box
                mx={isNewProfile ? 0 : 1}
                display={"block"}
                flexDirection={"row"}
                gap={2}
            >
                <TextField
                    type={showOldPassword ? 'text' : 'password'}
                    id="oldPassword-input"
                    label={t('profile.oldPassword')}
                    variant="outlined"
                    name='oldPassword'
                    className="filtros"
                    value={oldPassword}
                    onChange={handleChange}
                    onKeyPress={(e) => (e.key === "Enter" ? handleSubmit() : "")}
                    inputProps={{ "aria-label": "controlled" }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => setShowOldPassword(!showOldPassword)}>
                                    {showOldPassword ? <FiEyeOff /> : <FiEye />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    required
                />
                <TextField
                    type={showNewPassword ? 'text' : 'password'}
                    minLength="8"
                    id="newPassword-input"
                    label={t('profile.newPassword')}
                    variant="outlined"
                    name='NewPassword'
                    className="filtros"
                    value={newPassword}
                    onChange={handleChangePassword}
                    onKeyPress={(e) => (e.key === "Enter" ? handleSubmit() : "")}
                    inputProps={{ "aria-label": "controlled" }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => setShowNewPassword(!showNewPassword)}>
                                    {showNewPassword ? <FiEyeOff /> : <FiEye />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    required
                />
                <TextField
                    type={showRepeatPassword ? 'text' : 'password'}
                    id="password_confirmation-input"
                    label={t('profile.repeatPassword')}
                    variant="outlined"
                    name='repeatPassword'
                    className="filtros"
                    value={repeatPassword}
                    onChange={handleChangeRepeatPassword}
                    onKeyPress={(e) => (e.key === "Enter" ? handleSubmit() : "")}
                    inputProps={{ "aria-label": "controlled" }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={() => setShowRepeatPassword(!showRepeatPassword)}>
                                    {showRepeatPassword ? <FiEyeOff /> : <FiEye />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                    required
                />
                <Button className="btn-buscador" onClick={() => handleSubmit()}>
                    {t('profile.change')}
                </Button>
            </Box>
            <div style={{backgroundColor:'#fff', margin:0 }}>
                <p style={{ display: 'block', color: '#cf5c5c', fontWeight: 'normal', margin: '0 15 !important', padding: '0 15px' }}>{error}</p>
            </div>
            <div>
                <CheckPass password={newPassword} enviar={envio} passValida={passValida} />
            </div>
        </>
    );

    if (isNewProfile) {
        return (
            <>
                <div className="max-w-[800px] mx-auto px-5 py-5 max-sm:px-3">
                    <h1 className="text-2xl font-semibold text-gray-800 mb-8">{t('profile.title')}</h1>

                    <div className="mb-8">
                        <h2 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b border-gray-200">{t('profile.userData')}</h2>
                        <div className="grid grid-cols-2 gap-4 max-sm:grid-cols-1">
                            <div className="flex flex-col gap-1">
                                <label className="flex items-center gap-1.5 text-[13px] font-medium text-gray-500"><House className="w-5 h-5 text-[#3651d8]" strokeWidth={1.5} />{t('profile.name')}</label>
                                <span className="block px-3 py-2.5 border border-gray-300 rounded-md bg-gray-50 text-sm text-gray-800 min-h-[20px]">{aaff.razonSocial || '-'}</span>
                            </div>
                            <div className="flex flex-col gap-1">
                                <label className="flex items-center gap-1.5 text-[13px] font-medium text-gray-500"><IdCard className="w-5 h-5 text-[#3651d8]" strokeWidth={1.5} />NIF</label>
                                <span className="block px-3 py-2.5 border border-gray-300 rounded-md bg-gray-50 text-sm text-gray-800 min-h-[20px]">{aaff.nif || '-'}</span>
                            </div>
                            <div className="flex flex-col gap-1">
                                <label className="flex items-center gap-1.5 text-[13px] font-medium text-gray-500"><MapPin className="w-5 h-5 text-[#3651d8]" strokeWidth={1.5} />{t('profile.municipality')}</label>
                                <span className="block px-3 py-2.5 border border-gray-300 rounded-md bg-gray-50 text-sm text-gray-800 min-h-[20px]">{cambiarFormatoNombre(aaff.municipio) || '-'}</span>
                            </div>
                            <div className="flex flex-col gap-1">
                                <label className="flex items-center gap-1.5 text-[13px] font-medium text-gray-500"><MapPinned className="w-5 h-5 text-[#3651d8]" strokeWidth={1.5} />{t('profile.province')}</label>
                                <span className="block px-3 py-2.5 border border-gray-300 rounded-md bg-gray-50 text-sm text-gray-800 min-h-[20px]">{aaff.provincia || '-'}</span>
                            </div>
                        </div>
                    </div>

                    <div className="mb-8">
                        <h2 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b border-gray-200">{t('profile.contactData')}</h2>
                        <div className="grid grid-cols-2 gap-4 max-sm:grid-cols-1">
                            <div className="flex flex-col gap-1 col-span-2 max-sm:col-span-1">
                                <label className="flex items-center gap-1.5 text-[13px] font-medium text-gray-500"><AtSign className="w-5 h-5 text-[#3651d8]" strokeWidth={1.5} />{t('profile.email')}</label>
                                <span className="block px-3 py-2.5 border border-gray-300 rounded-md bg-gray-50 text-sm text-gray-800 min-h-[20px]">{aaff.user?.email || '-'}</span>
                            </div>
                            <div className="flex flex-col gap-1">
                                <label className="flex items-center gap-1.5 text-[13px] font-medium text-gray-500"><Phone className="w-5 h-5 text-[#3651d8]" strokeWidth={1.5} />{t('profile.phone')}</label>
                                <span className="block px-3 py-2.5 border border-gray-300 rounded-md bg-gray-50 text-sm text-gray-800 min-h-[20px]">{aaff.telefono || '-'}</span>
                            </div>
                            <div className="flex flex-col gap-1">
                                <label className="flex items-center gap-1.5 text-[13px] font-medium text-gray-500"><SquareUserRound className="w-5 h-5 text-[#3651d8]" strokeWidth={1.5} />{t('profile.contactPerson')}</label>
                                <span className="block px-3 py-2.5 border border-gray-300 rounded-md bg-gray-50 text-sm text-gray-800 min-h-[20px]">{aaff.nombreContacto || '-'}</span>
                            </div>
                        </div>
                    </div>

                    <div className="mb-8">
                        <h2 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b border-gray-200">{t('profile.accessData')}</h2>
                        <div className="grid grid-cols-2 gap-4 max-sm:grid-cols-1">
                            <div className="flex flex-col gap-1 col-span-2 max-sm:col-span-1">
                                <label className="flex items-center gap-1.5 text-[13px] font-medium text-gray-500"><Mail className="w-5 h-5 text-[#3651d8]" strokeWidth={1.5} />{t('profile.email')}</label>
                                <span className="block px-3 py-2.5 border border-gray-300 rounded-md bg-gray-50 text-sm text-gray-800 min-h-[20px]">{user.email || '-'}</span>
                            </div>
                            <div className="flex flex-col gap-1 col-span-2 max-sm:col-span-1">
                                <label className="flex items-center gap-1.5 text-[13px] font-medium text-gray-500"><RectangleEllipsis className="w-5 h-5 text-[#3651d8]" strokeWidth={1.5} />{t('profile.password')}</label>
                                <span className="block px-3 py-2.5 border border-gray-300 rounded-md bg-gray-50 text-sm text-gray-800 min-h-[20px]">••••••••</span>
                            </div>
                        </div>
                        <div className="flex justify-end mt-3">
                            <button
                                className="px-5 py-2 text-gray-800 bg-white border border-gray-300 rounded-xl text-sm cursor-pointer transition-colors duration-200 hover:bg-gray-100 hover:border-gray-400"
                                onClick={() => setShowChangePassword(true)}
                            >
                                {t('profile.changePassword')}
                            </button>
                        </div>
                    </div>

                    {showChangePassword && (
                        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[1000]" onClick={closePasswordModal}>
                            <div className="bg-white rounded-2xl w-full max-w-[520px] px-10 py-8 shadow-2xl max-sm:mx-4" onClick={(e) => e.stopPropagation()}>
                                <div className="flex justify-between items-center mb-8">
                                    <h3 className="text-lg font-bold text-gray-800 uppercase m-0">{t('profile.changePassword')}</h3>
                                    <button className="bg-transparent border-none cursor-pointer text-gray-400 p-1 flex items-center hover:text-gray-800" onClick={closePasswordModal}>
                                        <IoCloseOutline size={24} />
                                    </button>
                                </div>
                                <div className="flex flex-col gap-6">
                                    <div className="flex flex-col gap-2">
                                        <label className="text-sm font-medium text-gray-500">{t('profile.oldPassword')}</label>
                                        <div className="flex items-center w-full h-12 border border-gray-300 rounded-xl px-4 bg-white transition-all duration-150 focus-within:!border-[#92004D]">
                                            <input
                                                type={showOldPassword ? 'text' : 'password'}
                                                value={oldPassword}
                                                onChange={handleChange}
                                                onKeyPress={(e) => (e.key === "Enter" ? handleSubmit() : "")}
                                                className="flex-1 border-none outline-none text-[15px] text-gray-900 bg-transparent"
                                            />
                                            <button className="bg-transparent border-none cursor-pointer text-gray-400 p-1 flex items-center hover:text-gray-800" onClick={() => setShowOldPassword(!showOldPassword)}>
                                                {showOldPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="flex flex-col gap-2">
                                        <label className="text-sm font-medium text-gray-500">{t('profile.newPassword')}</label>
                                        <div className="flex items-center w-full h-12 border border-gray-300 rounded-xl px-4 bg-white transition-all duration-150 focus-within:!border-[#92004D]">
                                            <input
                                                type={showNewPassword ? 'text' : 'password'}
                                                value={newPassword}
                                                onChange={handleChangePassword}
                                                onKeyPress={(e) => (e.key === "Enter" ? handleSubmit() : "")}
                                                className="flex-1 border-none outline-none text-[15px] text-gray-900 bg-transparent"
                                            />
                                            <button className="bg-transparent border-none cursor-pointer text-gray-400 p-1 flex items-center hover:text-gray-800" onClick={() => setShowNewPassword(!showNewPassword)}>
                                                {showNewPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="flex flex-col gap-2">
                                        <label className="text-sm font-medium text-gray-500">{t('profile.repeatPassword')}</label>
                                        <div className="flex items-center w-full h-12 border border-gray-300 rounded-xl px-4 bg-white transition-all duration-150 focus-within:!border-[#92004D]">
                                            <input
                                                type={showRepeatPassword ? 'text' : 'password'}
                                                value={repeatPassword}
                                                onChange={handleChangeRepeatPassword}
                                                onKeyPress={(e) => (e.key === "Enter" ? handleSubmit() : "")}
                                                className="flex-1 border-none outline-none text-[15px] text-gray-900 bg-transparent"
                                            />
                                            <button className="bg-transparent border-none cursor-pointer text-gray-400 p-1 flex items-center hover:text-gray-800" onClick={() => setShowRepeatPassword(!showRepeatPassword)}>
                                                {showRepeatPassword ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                                            </button>
                                        </div>
                                    </div>
                                    {error && <p className="text-red-400 text-sm m-0">{error}</p>}
                                    <CheckPass password={newPassword} enviar={envio} passValida={passValida} />
                                </div>
                                <div className="flex justify-end mt-6">
                                    <button className="px-8 py-3 bg-gray-800 text-white border-none rounded-xl text-sm font-medium cursor-pointer transition-colors duration-200 hover:bg-gray-700" onClick={handleSubmit}>
                                        {t('profile.save')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="mb-8">
                        <h2 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b border-gray-200">{t('profile.apiAccess')}</h2>
                        <CaeToken />
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <BreadCrumb rutas={[{path:'/datosPerfil', label: t('profile.title')}]} style={{ margin: '0 10px'}} />
            {user.rol === "AAFF" &&
                <AAFF />
            }
            <div className="listPage">
                <div className="gridCard">
                    {user.rol !== "AAFF" &&
                        <>
                            <div className="gridHead">{t('profile.generalInfo')}</div>
                                <div className="gridSubhead editarSubhead">
                                <div>{t('profile.profileData')}</div>
                                <div
                                    className="editarBtn"
                                >
                                </div>
                            </div>
                            <div className="pageContent tableContainer">
                                <div className="datosGrid">
                                    <p>
                                        <b>{t('profile.name')}</b> {user.nombre}
                                    </p>
                                    <p>
                                        <b>{t('profile.email')}</b> {user.email}
                                    </p>
                                </div>
                            </div>
                        </>
                    }
                    <div className="gridSubhead editarSubhead">
                        <div>{t('profile.changePassword')}</div>
                    </div>
                    <div className="tableContainer">
                        {renderPasswordFields()}
                    </div>
                    {user.rol === "AAFF" &&
                    <>
                      <div className="gridSubhead editarSubhead">
                          <div>{t('profile.apiAccess')}</div>
                      </div>
                      <div className="tableContainer">
                        <CaeToken />
                      </div>
                    </>
                    }
                </div>
            </div>
            <style jsx="true">
                {`
                    .btn-buscador {
                    padding: 5px 10px;
                    color: #ffffff;
                    background-color: #92004D;
                    border-radius: 4px;
                    font-weight: bold;
                    width: -moz-fit-content;
                    width: fit-content;
                    align-self: flex-end;
                    border: none;
                    min-width:40px;
                    height:40px;
                    margin: 5px 0;
                    }
                    .btn-buscador:hover{
                    color: black;
                    background-color: #dee2e6;
                    }
                `}
            </style>
        </>
    );
}
 
export default DatosPerfil;
